<template>
  <span class="nebPill"
    @click="$emit('click')"
  >
    {{ text }}

    <span class="nebPill-close"
      v-if="closable"
      @click="onCloseClick"
    >
      X
    </span>
  </span>
</template>

<script>
export default {
  name: 'NebPill',

  props: {
    text: {
      type: String,
      required: true
    },
    closable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onCloseClick (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('close', e)
    }
  }
}
</script>

<style lang="scss">
.nebPill {
  display: block;
  border-radius: 3px;
  border: solid 1px #74cfe7;
  background-color: #e8f4fc;
  padding: 6px 12px;
  font-size: 12px;
  color: #5c5e62;
  line-height: 1;
  white-space: nowrap;

  &-close {
    font-size: 10px;
    cursor: pointer;
    padding-left: 3px;
  }
}
</style>
